import store from "../store";

const generateShareLink = () => {

    console.log("generate share link");

    const { origin } = window.location;
    
    // Get persisted state from storage (matches Redux Persist keys)
    const visualizerPersisted = localStorage.getItem('persist:visualizer');
    const floorplanPersisted = localStorage.getItem('persist:floorplan');

    // Also grab active elevation/scene from live Redux state for the specifier/sel
    const visualizerState = store.getState()["visualizer"];
    const activeElevation = visualizerState.activeElevation;
    const activeScene = visualizerState.activeScene;

    var shareLink = origin + "/shared/";
    var mydata = {
        visualizer: visualizerPersisted,
        floorplan: floorplanPersisted
    }; 
    
    var myimage = '{}';

    const shareData = {
        specifier: activeScene?.specifier || activeElevation?.specifier || '',
        sel: activeScene?.sel || '-1',
        url: shareLink,
        message: "Check out this design I made using the BuffingtonHomes Visualizer!"
    }

    // Avoid calling for actual lizard proxy on localhost
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortener(shareLink, "BuffingtonHomes", JSON.stringify(mydata), myimage).then(function (r) {
            var arr = r.data.shortUrl.split('/');
            shareData["url"] = shareLink + arr[arr.length - 1];
            console.log(shareData);
            resolve(shareData);
            });
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve(shareData);
        });
    }
}

const loadShareLink = (code) => {
    const { origin } = window.location;
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortenerData(code).then(function(r) {
                resolve(r.data)
            })
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve("");
        });
    }
}

export {generateShareLink, loadShareLink}

